import { createSelector } from "reselect";

export const selectSearches = (state) => state.search.data;
export const selectSearchCriteriaTypes = (state) => state.search.types;